import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getYMSYard = async () => {
  try {
    const response = await commonDefaultAPI.get(`ymsyard`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};
export default getYMSYard;
